// extracted by mini-css-extract-plugin
module.exports = {"section":"GalleryShortsVideo_section__zqHk4"};